import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { post } from '../../util/api';
import { parseContactFile } from '../../util/contacts';
import { Btn, IconBtn, Card, PageHead, SearchInput, Select, Field, Input, Tag, Stat, Empty, Loading, Modal, ConfirmModal, Pager, Spinner, COLORS, notify, num, paginate, searchMatch } from './ui';

class Tables extends Component {
	constructor(props) {
		super(props);
		this.currentPage = 1;
		this.cellsPerPage = 100;
	}

	state = {
		loading: true,
		saveButton: 'add',
		ex_file: '',
		isAddUserModalOpen: false,
		list: [],
		numberList: [],
		selectedExcel: null,
		deleteButtonLoading: false,
		deleteModal: false,
		loadingBtn: false,
		message: false,
		openDeleteModal: false,
		currentPage: 1,
	};

	openAddUserModal = () => {
		this.setState({ isAddUserModalOpen: true });
	};

	closeAddUserModal = () => {
		this.setState({ isAddUserModalOpen: false, openDeleteModal: false, selectedUserId: '', openEditModal: false });
	};

	componentDidMount() {
		this.getTagList();
		this.getList();
	}
	handlePageChange = (newPage, list) => {
		const totalPages = Math.ceil(list.length / this.cellsPerPage);
		if (newPage >= 1 && newPage <= totalPages) {
			//this.currentPage = newPage;
			this.setState({ currentPage: newPage });
			//this.getList();
		}
	};

	async getList() {
		const { product } = this.props;
		let pid = product.id;
		await post('/broadcast/listBroadcastUser', { pid }).then((data) => {
			let list = data.data.result;
			console.log('loading', list);
			this.setState({
				list,
				filtered_list: list,
				selectedUserId: '',
				loading: false,
				isAddUserModalOpen: false,
				openDeleteModal: false,
				loadingBtn: false,
				openEditModal: false,
				name: '',
				phone: '',
				selectedUser: '',
				selectedUserId: '',
			});
		});
	}
	async getTagList() {
		await post('/dahi/tag/list').then((data) => {
			let result = data.data && data.data.result && data.data.result.result;
			this.setState({ tagList: _.filter(result, { active: true }) });
		});
	}
	async addUser() {
		const { product } = this.props;
		let pid = product.id;
		let { name, phone, tag } = this.state;
		let body = {
			pid,
			name,
			phone,
			data: { tag },
		};
		await post('/broadcast/createBroadcastUserList', body);
		this.getList();
	}

	/* async addUserExcel(data) {
		const { product } = this.props;
		let pid = product.id;
		let users = _.map(data, (it) => ({
			name: it.Name,
			phone: it.Phone,
			data: { tag: it.Label },
		}));
		let body = {
			pid,
			users,
		};
		await post('/broadcast/createBroadcastUserListExcel', body);
		this.getList();
	} */

	async addUserExcel(data) {
		const { product } = this.props;
		let pid = product.id;

		for (let i = 0; i < data.length; i += 500) {
			let chunk = data.slice(i, i + 500);

			let users = _.map(chunk, (it) => ({
				name: it.Name,
				phone: it.Phone,
				data: { tag: [it.Label] },
			}));

			let body = {
				pid,
				users,
			};
			await post('/broadcast/createBroadcastUserListExcel', body);
		}

		// Liste güncellemesini burada çağırabilirsiniz, eğer gerekliyse
		this.getList();
	}
	async deleteUser() {
		const { product } = this.props;
		let pid = product.id;
		let { selectedUserId } = this.state;
		let body = { pid, id: selectedUserId };
		await post('/broadcast/deleteBroadcastUser', body);
		this.getList();
	}
	async updateUser() {
		const { product } = this.props;
		let pid = product.id;
		let { selectedUser } = this.state;
		let body = {
			pid,
			id: selectedUser.id,
			user: selectedUser,
		};
		await post('/broadcast/updateBroadcastUser', body);
		this.getList();
	}

	fileUpload(file) {
		let { t } = this.props;
		this.setState({ loadingBtn: true });
		parseContactFile(file)
			.then(async (data) => {
				if (data && data.success) {
					await this.addUserExcel(data.rows);
					notify(t('messageExcelSuccess') + ' (' + num(data.rows.length) + ')');
				} else notify((data && data.error) || t('Dosya okunamadı.'), 'err');
				this.setState({ loadingBtn: false });
			})
			.catch(() => {
				this.setState({ loadingBtn: false });
				notify(t('Dosya okunamadı.'), 'err');
			});
	}

	handleFileInput = (e) => {
		let file = e.target.files[0];
		e.target.value = '';
		if (file) this.fileUpload(file);
	};

	downloadExample = async () => {
		var a = document.createElement('a');
		a.href = '/contacts_example.xlsx';
		a.target = '_blank';
		a.download = 'contacts_example.xlsx';
		a.click();
	};
	handleSearch = async (e, { value }) => {
		let regex = new RegExp(value);
		let list = this.state.list;
		console.log('regex', regex, list);
		let filtered_list = value ? _.filter(list, (it) => (it && it.name && regex.test(it.name.toLocaleLowerCase('tr'))) || regex.test(it.phone)) : list;
		this.setState({ filtered_list });
	};
	renderTagPicker(value, onChange) {
		let { tagList } = this.state;
		let selected = value || [];
		if (!tagList || !tagList.length) return <div className="wsm-hint">{this.props.t('Tanımlı etiket yok.')}</div>;
		return (
			<div className="wsm-tags">
				{tagList.map((tg) => {
					let on = _.includes(selected, tg.title);
					return (
						<button
							key={tg._id}
							type="button"
							className="wsm-tag"
							style={{ cursor: 'pointer', fontSize: 12, padding: '4px 10px', borderColor: on ? COLORS.primary : undefined, background: on ? '#E7F4EE' : undefined, color: on ? COLORS.primary : undefined }}
							onClick={() => onChange(on ? _.without(selected, tg.title) : selected.concat(tg.title))}
						>
							<i style={{ background: tg.color || '#999' }} />
							{tg.title}
						</button>
					);
				})}
			</div>
		);
	}
	render() {
		const { t } = this.props;
		let { loadingBtn, list, loading, tagList, selectedUser, q, tagFilter, currentPage } = this.state;
		if (loading) return <Loading />;
		list = list || [];
		let rows = _.filter(list, (it) => {
			if (tagFilter && !_.includes(it.data && it.data.tag, tagFilter)) return false;
			return searchMatch(q, it.name, it.phone);
		});
		let pageRows = paginate(rows, currentPage, this.cellsPerPage);
		let tagged = _.filter(list, (it) => it.data && it.data.tag && _.compact(it.data.tag).length).length;
		let colorOf = (title) => {
			let tg = _.find(tagList, { title });
			return tg && tg.color;
		};
		return (
			<div>
				<PageHead
					title={t('contacts')}
					desc={t('Toplu gönderim kişi listesi. Listeden çıkanlara gönderim yapılmaz.')}
					right={
						<>
							<Btn variant="ghost" icon="download" onClick={() => this.downloadExample()}>
								{t('example download')}
							</Btn>
							<label className="wsm-btn ghost" style={{ cursor: loadingBtn ? 'progress' : 'pointer' }}>
								{loadingBtn ? <Spinner size={14} /> : null}
								{t('Excel yükle')}
								<input type="file" accept=".xlsx, .xls" style={{ display: 'none' }} disabled={loadingBtn} onChange={this.handleFileInput} />
							</label>
							<Btn icon="userPlus" onClick={() => this.setState({ isAddUserModalOpen: true, name: '', phone: '', tag: [] })}>
								{t('addUser')}
							</Btn>
						</>
					}
				/>
				<div className="wsm-stats">
					<Stat label={t('Toplam kişi')} value={num(list.length)} />
					<Stat label={t('Etiketli')} value={num(tagged)} color={COLORS.primary} />
					<Stat label={t('Etiketsiz')} value={num(list.length - tagged)} color={COLORS.muted} />
				</div>
				<Card>
					<div className="wsm-section">
						<div className="wsm-row" style={{ gap: 10 }}>
							<SearchInput value={q} onChange={(v) => this.setState({ q: v, currentPage: 1 })} placeholder={t('İsim veya numara ara…')} />
							{tagList && tagList.length ? (
								<Select
									auto
									value={tagFilter || ''}
									options={[{ value: '', label: t('Etiket') + ': ' + t('Hepsi') }].concat(_.map(tagList, (tg) => ({ value: tg.title, label: tg.title })))}
									onChange={(v) => this.setState({ tagFilter: v, currentPage: 1 })}
								/>
							) : null}
						</div>
					</div>
					{!list.length ? (
						<Empty compact icon="users" title={t('Henüz kişi yok')} desc={t('Excel yükleyerek veya tek tek ekleyerek başlayın.')} />
					) : (
						<>
							<div className="wsm-table-wrap">
								<table className="wsm-table" style={{ minWidth: 620 }}>
									<thead>
										<tr>
											<th style={{ width: 60 }}>#</th>
											<th>{t('name')}</th>
											<th>{t('phone')}</th>
											<th>{t('label')}</th>
											<th className="r">{t('İşlem')}</th>
										</tr>
									</thead>
									<tbody>
										{pageRows.map((it, index) => (
											<tr key={it.id || index}>
												<td className="wsm-faint">{(currentPage - 1) * this.cellsPerPage + index + 1}</td>
												<td style={{ fontWeight: 500 }}>{it.name || <span className="wsm-faint">—</span>}</td>
												<td className="wsm-muted wsm-nowrap">{it.phone}</td>
												<td>
													{it.data && it.data.tag && _.compact(it.data.tag).length ? (
														<div className="wsm-tags">
															{_.compact(it.data.tag).map((tg) => (
																<Tag key={tg} color={colorOf(tg)}>
																	{tg}
																</Tag>
															))}
														</div>
													) : (
														<span className="wsm-faint">—</span>
													)}
												</td>
												<td className="r">
													<div className="wsm-row" style={{ justifyContent: 'flex-end', gap: 6, flexWrap: 'nowrap' }}>
														<IconBtn
															icon="edit"
															title={t('editUser')}
															onClick={() => this.setState({ openEditModal: true, selectedUser: { ...it, data: { ...(it.data || {}), tag: _.compact((it.data && it.data.tag) || []) } } })}
														/>
														<IconBtn icon="trash" danger title={t('deleteUser')} onClick={() => this.setState({ openDeleteModal: true, selectedUserId: it.id })} />
													</div>
												</td>
											</tr>
										))}
										{!pageRows.length ? (
											<tr>
												<td colSpan={5} className="wsm-empty-row">
													{t('Aramanızla eşleşen kayıt bulunamadı.')}
												</td>
											</tr>
										) : null}
									</tbody>
								</table>
							</div>
							<Pager
								page={currentPage}
								pageSize={this.cellsPerPage}
								total={rows.length}
								onChange={(p) => this.setState({ currentPage: p })}
								label={`${num(rows.length)} ${t('kişi')}`}
							/>
						</>
					)}
				</Card>

				{this.state.isAddUserModalOpen ? (
					<Modal
						title={t('addUser')}
						icon="userPlus"
						width={480}
						onClose={this.closeAddUserModal}
						footer={
							<>
								<Btn variant="ghost" onClick={this.closeAddUserModal}>
									{t('cancel')}
								</Btn>
								<Btn disabled={!this.state.name || !this.state.phone} onClick={() => this.addUser()}>
									{t('add')}
								</Btn>
							</>
						}
					>
						<div className="wsm-col">
							<Field label={t('name')} required>
								<Input value={this.state.name} onChange={(v) => this.setState({ name: v })} placeholder={t('name')} />
							</Field>
							<Field label={t('phone')} required hint={t('Ülke koduyla') + ': 905XXXXXXXXX'}>
								<Input type="tel" value={this.state.phone} onChange={(v) => this.setState({ phone: v })} placeholder="905XXXXXXXXX" />
							</Field>
							<Field label={t('label')}>{this.renderTagPicker(this.state.tag, (tag) => this.setState({ tag }))}</Field>
						</div>
					</Modal>
				) : null}
				{this.state.openDeleteModal ? (
					<ConfirmModal
						title={t('deleteUser')}
						body={t('areYouSureDeleteUser')}
						confirmText={t('yes')}
						cancelText={t('no')}
						onClose={this.closeAddUserModal}
						onConfirm={() => this.deleteUser()}
					/>
				) : null}
				{selectedUser && this.state.openEditModal ? (
					<Modal
						title={t('editUser')}
						icon="edit"
						width={480}
						onClose={this.closeAddUserModal}
						footer={
							<>
								<Btn variant="ghost" onClick={this.closeAddUserModal}>
									{t('cancel')}
								</Btn>
								<Btn disabled={!selectedUser.name || !selectedUser.phone} onClick={() => this.updateUser()}>
									{t('update')}
								</Btn>
							</>
						}
					>
						<div className="wsm-col">
							<Field label={t('name')} required>
								<Input value={selectedUser.name} onChange={(v) => this.setState({ selectedUser: { ...selectedUser, name: v } })} />
							</Field>
							<Field label={t('phone')} required>
								<Input type="tel" value={selectedUser.phone} onChange={(v) => this.setState({ selectedUser: { ...selectedUser, phone: v } })} />
							</Field>
							<Field label={t('label')}>
								{this.renderTagPicker(selectedUser.data && selectedUser.data.tag, (tag) =>
									this.setState({ selectedUser: { ...selectedUser, data: { ...(selectedUser.data || {}), tag } } })
								)}
							</Field>
						</div>
					</Modal>
				) : null}
			</div>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(withTranslation()(Tables));
